import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getEventByEventId } from "apis/EventServiceApi";
import { RootState } from "store/types";
import { IEventData } from "types";

interface RecommendedEventDetailState {
  data: IEventData | null;
  isLoading: boolean;
  error: string | null;
  isOpen: boolean;
  selectedEventId: number | null;
}

const initialState: RecommendedEventDetailState = {
  data: null,
  isLoading: false,
  error: null,
  isOpen: false,
  selectedEventId: null,
};

export const fetchRecommendedEventDetail = createAsyncThunk(
  "recommendedEventDetail/fetchRecommendedEventDetail",
  async (eventId: number, { rejectWithValue }) => {
    try {
      const response = await getEventByEventId({ id: eventId });
      return response;
    } catch (error: any) {
      let errMsg = "Error fetching event detail";
      if (error?.response?.data?.message) {
        errMsg = error.response.data.message;
      } else if (error.message) {
        errMsg = error.message;
      }
      return rejectWithValue(errMsg);
    }
  }
);

const recommendedEventDetailSlice = createSlice({
  name: "recommendedEventDetail",
  initialState,
  reducers: {
    openRecommendedEventModal: (state, action) => {
      state.isOpen = true;
      state.selectedEventId = action.payload;
      state.error = null;
      state.data = null;
    },
    closeRecommendedEventModal: (state) => {
      state.isOpen = false;
      state.selectedEventId = null;
      state.data = null;
      state.error = null;
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecommendedEventDetail.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchRecommendedEventDetail.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchRecommendedEventDetail.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { openRecommendedEventModal, closeRecommendedEventModal } =
  recommendedEventDetailSlice.actions;

export const selectRecommendedEventDetail = (state: RootState) =>
  state.recommendedEventDetail;

export default recommendedEventDetailSlice.reducer;
